/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MailArrowOutIcon16Light } from './MailArrowOutIcon16Light';
import { MailArrowOutIcon16Regular } from './MailArrowOutIcon16Regular';
import { MailArrowOutIcon16Solid } from './MailArrowOutIcon16Solid';
import { MailArrowOutIcon20Light } from './MailArrowOutIcon20Light';
import { MailArrowOutIcon20Regular } from './MailArrowOutIcon20Regular';
import { MailArrowOutIcon20Solid } from './MailArrowOutIcon20Solid';
import { MailArrowOutIcon24Regular } from './MailArrowOutIcon24Regular';
import { MailArrowOutIcon24Solid } from './MailArrowOutIcon24Solid';
import { MailArrowOutIcon32Regular } from './MailArrowOutIcon32Regular';
import { MailArrowOutIcon64Regular } from './MailArrowOutIcon64Regular';
var sizes = {
    16: {
        light: MailArrowOutIcon16Light,
        regular: MailArrowOutIcon16Regular,
        solid: MailArrowOutIcon16Solid,
    },
    20: {
        light: MailArrowOutIcon20Light,
        regular: MailArrowOutIcon20Regular,
        solid: MailArrowOutIcon20Solid,
    },
    24: {
        regular: MailArrowOutIcon24Regular,
        solid: MailArrowOutIcon24Solid,
    },
    32: {
        regular: MailArrowOutIcon32Regular,
    },
    64: {
        regular: MailArrowOutIcon64Regular,
    },
};
export var MailArrowOutIcon = forwardRef('MailArrowOutIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
